import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
		lastScroll: 0,
	},
	init: function () {
		var self = this;

		// Global
		self.smoothScroll.init();
		self.onloadClass();
		self.touch();
		self.floater();
		self.video();

		self.tilesSlider();

		// modal.init();
		hamburger.init();
	},
	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},
	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},
	floater: function() {
		// console.log( jQuery('#site-footer').isOnScreen() );
		
		if( jQuery('#site-footer').isOnScreen() === true ) {
			jQuery( 'body' ).addClass( 'remove-floater' );
		} else {
			jQuery( 'body' ).removeClass( 'remove-floater' );
		}
	},
	video: function() {
		var self = this;

		jQuery(document).on( 'click', '.skoumal-video__clicker', function() {
			let video = jQuery( this ).parent().find( 'video' ).get(0);
			
			if( jQuery( this ).parent().hasClass( 'is-playing' ) ) {
				video.pause();
				jQuery( this ).parent().removeClass( 'is-playing' );
			} else {
				video.play();
				jQuery( this ).parent().addClass( 'is-playing' );
			}
		});
	},
	/* loadFancy: function() {
		// jQuery( 'p a[rel="noopener"]' ).has("img").fancybox(); class="fancybox" data-fancybox="gallery"
		jQuery( '.gallery-row a' ).each(function(){
			jQuery(this).attr( 'data-fancybox', 'gallery' );
		});
	}, */
	tilesSlider: function () {
		var arrow = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve"> <path d="M388.425,241.951L151.609,5.79c-7.759-7.733-20.321-7.72-28.067,0.04c-7.74,7.759-7.72,20.328,0.04,28.067l222.72,222.105 L123.574,478.106c-7.759,7.74-7.779,20.301-0.04,28.061c3.883,3.89,8.97,5.835,14.057,5.835c5.074,0,10.141-1.932,14.017-5.795 l236.817-236.155c3.737-3.718,5.834-8.778,5.834-14.05S392.156,245.676,388.425,241.951z"/></svg>';

		if( jQuery(".js-tilesSlider").length ) {
			var slider = tns({
				container: '.js-tilesSlider',
				items: 3,
				center: false,
				loop: false,
				swipeAngle: false,
				speed: 400,
				gutter: 48,
				controls: true,
				controlsText: [ arrow, arrow ],
				mouseDrag: true,
				responsive: {
					1024: {
						items: 3,
						gutter: 24,
					},
					728: {
						items: 2,
						gutter: 24,
					},
					0: {
						items: 1
					},
				  }
			});
		}

		/* if( jQuery(".js-loogSlider").length ) {
			var slider = tns({
				container: '.js-loogSlider',
				loop: true,
				autoplay: true,
				// autoplayHoverPause: true,
				autoplayButtonOutput: false,
				controls: false,
				nav: false,
				speed: 1500,
				gutter: 48,
				autoplayTimeout: 0,
				preventActionWhenRunning: true,
				mouseDrag: true,
				autoWidth: true,
			});
		} */
	},
	smoothScroll: {
		selector: 'a[href*="#"]',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: 87,
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},
	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;

		self.floater();
	},
	onscroll(position, previusPosition) {
		var self = this;
		
		self.floater();
	},
};

jQuery(document).ready(function ($) {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 

jQuery.fn.isOnScreen = function(){
    var win = jQuery(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};